// text-reveal.js — mobile optimised, replays on scroll
(function () {
  if (!document.body.classList.contains('template-index')) return;

  var SELECTORS = [
    'h1', 'h2', 'h3',
    'p',
    '.rte p', '.rte h2', '.rte h3',
    'figcaption',
    '.button', '.btn',
    'a.button', 'button.button',
    '.hero__title', '.banner__heading', '.banner__subheading',
    '.section-header__title', '.section-header p',
    '.rich-text__heading', '.rich-text__text',
    '.featured-collection .title',
    '.card__heading', '.card__text',
    '.custom-liquid p', '.custom-liquid h2', '.custom-liquid h3'
  ].join(', ');

  var SKIP = ['header', 'footer', 'nav', '#shopify-section-header', '#shopify-section-footer'];

  function shouldSkip(el) {
    for (var i = 0; i < SKIP.length; i++) {
      if (el.closest(SKIP[i])) return true;
    }
    if (el.closest('.ir-section')) return true;
    return false;
  }

  function init() {
    var elements = document.querySelectorAll(SELECTORS);
    elements.forEach(function (el) {
      if (shouldSkip(el)) return;
      el.classList.add('tr-animate');
      if (el.tagName === 'BUTTON' || el.classList.contains('button') || el.classList.contains('btn')) {
        el.classList.add('tr-btn');
      }
      var parent = el.parentElement;
      if (!parent._trIdx) parent._trIdx = 0;
      parent._trIdx++;
      el.classList.add('tr-delay-' + Math.min(parent._trIdx, 6));
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /* Add class when entering, remove when leaving — so it replays */
          if (entry.isIntersecting) {
            entry.target.classList.add('tr-visible');
          } else {
            entry.target.classList.remove('tr-visible');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      });

      document.querySelectorAll('.tr-animate').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      document.querySelectorAll('.tr-animate').forEach(function (el) {
        el.classList.add('tr-visible');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();